import type { PlaygroundNodeData } from "@/utils/playground/workflowToNodes";

import React from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Icon } from "@iconify/react";

import { useTheme } from "@/hooks/use-theme";

const PlaygroundToolNode: React.FC<NodeProps> = ({ data, selected }) => {
  const nodeData = data as PlaygroundNodeData;
  const { isDark } = useTheme();

  return (
    <div
      className={`
        px-3 py-2 rounded-lg border min-w-[140px] transition-all duration-200
        ${selected ? "ring-2 ring-gray-400 ring-offset-2" : ""}
        ${isDark ? "bg-default-100 border-default-300" : "bg-white border-gray-200"}
        shadow-sm hover:shadow-md
      `}
    >
      <div className="flex items-center gap-2">
        <div
          className={`
            rounded-md w-7 h-7 flex items-center justify-center shrink-0
            ${isDark ? "bg-default-200" : "bg-gray-100"}
          `}
        >
          <Icon
            className={`w-4 h-4 ${isDark ? "text-default-500" : "text-gray-500"}`}
            icon={nodeData.toolIcon || "qlementine-icons:tool-16"}
          />
        </div>
        <span
          className={`text-xs font-medium truncate ${isDark ? "text-default-700" : "text-gray-700"}`}
        >
          {nodeData.label}
        </span>
      </div>

      <Handle
        className="!w-2.5 !h-2.5 !bg-gray-400 !border-2 !border-white"
        position={Position.Left}
        type="target"
      />
      <Handle
        className="!w-2.5 !h-2.5 !bg-gray-400 !border-2 !border-white"
        position={Position.Right}
        type="source"
      />
    </div>
  );
};

export default PlaygroundToolNode;
